import { distribution, GLOBAL_LANGUAGES } from '@/app/constants';
import type { SupportedLanguage } from '@/app/types';

// allowlist 按不带 locale 的业务路径维护，proxy 匹配前统一剥掉语言前缀。
export const stripRouteLocale = (pathname: string): string => {
  const segments = pathname.split('/');
  const maybeLocale = segments[1];
  const hasLocale = GLOBAL_LANGUAGES.includes(maybeLocale as SupportedLanguage);
  const pathWithoutLocale = hasLocale ? `/${segments.slice(2).join('/')}` : pathname;

  return pathWithoutLocale === '' ? '/' : pathWithoutLocale;
};

export const matchDistributionRouteRule = (pathname: string, rule: string): boolean => {
  if (rule.endsWith('/**')) {
    const basePath = rule.slice(0, -3);
    // '/foo/**' 同时允许 '/foo' 和 '/foo/bar'，避免额外维护根路径规则。
    return pathname === basePath || pathname.startsWith(`${basePath}/`);
  }

  return pathname === rule;
};

export const isDistributionRouteAllowed = (pathname: string, allowlist: readonly string[]): boolean => {
  const normalizedPathname = stripRouteLocale(pathname);

  // 任一 deny 子规则（以 `!` 开头）命中即拒绝，优先级高于 allow。
  // 用于在 `/create/**` 这类粗粒度允许下精准排除少数子路径（如 `!/create/ai-video-cutter`）。
  for (const rule of allowlist) {
    if (rule.startsWith('!') && matchDistributionRouteRule(normalizedPathname, rule.slice(1))) {
      return false;
    }
  }

  return allowlist.some((rule) => !rule.startsWith('!') && matchDistributionRouteRule(normalizedPathname, rule));
};

export const isDistributionRouteVisible = (pathname?: string): boolean => {
  if (!pathname || distribution.routes.mode !== 'allowlist') {
    return true;
  }

  return isDistributionRouteAllowed(pathname, distribution.routes.allowlist);
};
